<template>
    <v-dialog v-model="dialog" scrollable>
        <v-card>
            <v-card-title class="headline primary white--text" primary-title>
                Pedido de venta {{ encab.C5_NUM }}
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogClose">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md fluid>
                    <v-layout>
                        <v-flex>
                            Número<br>
                            {{ encab.C5_NUM }}
                        </v-flex>
                        <v-flex>
                            Fecha de emisión<br>
                            {{ encab.C5_EMISSAO | fecha-micro }}
                        </v-flex>
                        <v-flex>
                            Cliente<br>
                            {{ encab.A1_NOME }} ({{ encab.C5_CLIENTE }})
                        </v-flex>
                        <v-flex>
                            Condición de pago<br>
                            {{ encab.C5_USCONDP }}
                        </v-flex>
                        <v-flex>
                            Vendedor<br>
                            {{ encab.C5_VEND1 }}
                        </v-flex>
                        <v-flex>
                            Ped. Compra<br>
                            {{ encab.C5_USORDCO }}
                        </v-flex>
                        <v-flex>
                            Cond. Especiales<br>
                            {{ encab.C5_USCOND }}
                        </v-flex>
                        <v-flex>
                            Moneda<br>
                            {{ encab.C5_TXMOEDA | moneda-txt }}
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <v-data-table
                                    :headers="headers"
                                    :items="items"
                                    class="elevation-1"
                                    hide-actions
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">{{ props.item.C6_PRODUTO }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_DESCRI }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_QTDVEN | moneda}}</td>
                                    <td class="text-xs-center">{{ props.item.C6_UM }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_UNSVEN | moneda }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_SEGUM }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_PRCVEN | moneda(encab.C5_TXMOEDA)}}</td>
                                    <td class="text-xs-center">{{ props.item.C6_VALOR | moneda(encab.C5_TXMOEDA)}}</td>
                                    <td class="text-xs-center">{{ props.item.C6_LARGPZA | moneda }}</td>
                                    <td class="text-xs-center">{{ props.item.C6_LOCAL }}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import mixinPedido from '../mixins/pedidoventa';
    import monedaTxt from '../filters/monedaTxt';
    import moneda from '../filters/moneda';
    import fechaMicro from '../filters/fecha-micro';

    export default {
        name: "PedidoVentaDialog",
        props: ['value', 'emp', 'pedido'],
        mixins: [mixinPedido],
        filters: {fechaMicro, monedaTxt, moneda},
        data() {
            return {
                encab: [],
                items: [],
                dialog: false,
                headers: [
                    {text: 'Producto', value: 'C6_PRODUTO'},
                    {text: 'Descripción', value: 'C6_DESCRI'},
                    {text: 'Cantidad', value: 'C6_QTDVEN'},
                    {text: 'Unidad', value: 'C6_UM'},
                    {text: 'Cant. Vent. 2ºUn', value: 'C6_UNSVEN'},
                    {text: '2º Unidad', value: 'C6_SEGUM'},
                    {text: 'Precio Unit', value: 'C6_PRCVEN'},
                    {text: 'Valor Total', value: 'C6_VALOR'},
                    {text: 'Largo Pza', value: 'C6_LARGPZA'},
                    {text: 'Depósito', value: 'C6_LOCAL'},
                ],
            }
        },
        watch: {
            value(val) {
                if (val) {
                    this.getData()
                } else {
                    this.dialog = false;
                }
            }
        },
        methods: {
            getData() {
                this.pedidoShow({emp: this.emp, id: this.pedido}, r => {
                    this.encab = r.encab;
                    this.items = r.items;
                    this.dialog = true;
                    this.$emit('input', true)
                }, err => console.log(err));
            },
            dialogClose(){
                this.$emit('input', false)
            }
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PedidoVentaDialog.vue